import styled from '@emotion/styled';

export const ProjectWrapper = styled.div`
  position: absolute;
  top: ${({position}) => `${position.y}%`};
  left: ${({position}) => `${position.x}%`};
  z-index: ${({active}) => (active ? '2' : '1')};
  opacity: 1;
  transition: opacity 500ms linear;
`;

export const ProjectIcon = styled.div`
  transition: transform 0.2s linear;
  transform: ${({active}) => (active ? `scale(2)` : `scale(1)`)};
  width: 25px;
  height: 25px;
  cursor: pointer;
  svg {
    width: 100%;
    height: auto;
  }
`;
